import { Breadcrumb } from 'antd';
import React from 'react';

const Breadcrumbs = ({ items }) => {
    return (
        <Breadcrumb
            style={{ paddingLeft: 60, paddingTop: 30 }}
            separator=">"
            items={[{
                title: 'Home',
                href: '/',
            },
            ...items]}
        />);
}

export default Breadcrumbs;